<template>
  <hs-dialog v-model="show" ref="detailsDialog">
    <div class="select-business-book">
      <c-dialog-header v-if="type === 'new-style'" :title="$t('ApplicationForBook')" @close="close"/>
      <hs-date-header v-else :title="list[0] && list[0].Code" @close="close"/>
      <hs-scroll class="table-view" :data="[]" @click.native.stop>
        <ul>
          <div class="list" v-if="type === 'new-style'">
            <select-business-book-item v-for="(item, index) in list" :item="item" :key="index" @select="_select" />
          </div>
          <div class="list" v-else>
            <div class="item" v-for="(item, index) in list" :key="index" @click.stop="$emit('select', item)">
              <div>
                <c-order-list-cell-icon :OrderBusinessType="item.OrderBusinessType" />
                {{_getBusinessName(item.OrderBusinessType)}}
              </div>
              <div class="to-details">
                {{item.OrderBusinessType === 17 ? $t('GoEnquiry') : $t('GoBook')}}<div class="icon-arrow-right-default"></div>
              </div>
            </div>
          </div>
          <div style="height: 30px"></div>
        </ul>
      </hs-scroll>
    </div>
  </hs-dialog>
</template>
<script type="text/ecmascript-6">
import HsDialog from 'base/hs-dialog/hs-dialog'
import HsScroll from 'base/hs-scroll/hs-scroll'
import CDialogHeader from "@/components/c-header/c-dialog-header.vue";
import SelectBusinessBookItem from "@/pages/home/select-business-book-item.vue";
export default {
  props: {
    list: {
      type: Array,
      default: function() {
        return []
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      selectIndex: 0
    }
  },
  methods: {
    open() {
      this.selectIndex = 0
      this.show = true
    },
    close() {
      this.$refs.detailsDialog && this.$refs.detailsDialog.close()
    },

    _getBusinessName(OrderBusinessType) {
      // 机票预订 1 国际机票预订 6 酒店预订 2 海外酒店 11 火车票 10 用车 14 国际机票需求单 17
      if (OrderBusinessType === 1) {
        return this.$t('DomesticFlights')
      }

      if (OrderBusinessType === 6) {
        return this.$t('IntlFlights')
      }

      if (OrderBusinessType === 17) {
        return this.$t('IntlFlightEnquiry')
      }

      if (OrderBusinessType === 2) {
        return this.$t('DomesticHotel')
      }

      if (OrderBusinessType === 11) {
        return this.$t('IntlHotel')
      }

      if (OrderBusinessType === 10) {
        return this.$t('TrainTicket')
      }

      if (OrderBusinessType === 14) {
        return this.$t('Car')
      }
    },

    _select(item) {
      this.$emit('select', item)
    }
  },
  components: {
    COrderListCellIcon: () => import('components/c-order-list-cell/c-order-list-cell-icon'),
    HsDateHeader: () => import('base/hs-date-picker/hs-date-header'),
    SelectBusinessBookItem,
    CDialogHeader,
    HsDialog,
    HsScroll
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.select-business-book
  position absolute
  width 100%
  left 0
  bottom 0
  background-size 100% 100%
  background-color $color_white
  border-radius 10px 10px 0 0
  overflow hidden
  >.header
    @extend .flex-row
    @extend .flex-between
    width 100%
    height 50px
    padding 0 15px
    border-radius 10px 10px 0 0
    background-color $color_white
    >.logo
      width 20px
      height 20px
      background-size 100% 100%
    >p
      font-weight bold
      font-size 1.1rem
  .table-view
    width 100%
    max-height calc(70vh - 70px)
    overflow hidden
  .list
    padding 0 12px
    >.item
      @extends.flex-between
      font-size 15px
      padding 10px 14px
      min-height 60px
      background $color_background_blue_10
      border-radius 5px
      margin-bottom 11px
      border 1px solid $color_border_blue_8
      &:last-child
        margin-bottom 0
      >div:first-child
        @extend.flex-center
        >.c-order-list-cell-icon
          width 20px
          height 20px
      >div:last-child
      >.to-details
        @extends .flex-between
        font-size 12px
        color $color_font_blue_16
        >.icon-arrow-right-default
          width 12px
          height 12px
          margin-left 5px
</style>
